var ndef=null
var ctrl=null
function scan(callback){
    try {
        ctrl = new AbortController();
        ctrl.signal.onabort = () =>{

        }
        ndef = new NDEFReader();
        ndef.scan({signal: ctrl.signal }).then(()=>{
            console.log("> Scan started");
        
            ndef.addEventListener("readingerror", () => {
                // ctrl.abort();
                callback({
                    error:"Argh! Cannot read data from the NFC tag. Try another one?"
                })
            });
        
            ndef.addEventListener("reading", ({ message, serialNumber }) => {
                // ctrl.abort();
                console.log(`> Serial Number: ${serialNumber}`);
                console.log(`> Records: (${message.records.length})`);
                callback({
                    serialNumber
                })
            });
        });

      } catch (error) {
        callback({
            error:"nfchelper scan error: " + error.toString()
        })
      }
}
function abort(){
    if(ctrl!=null)
        ctrl.abort();
}
export default{
    scan,
    abort
}